// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.
import React from 'react';
import { Avatar, Card, Typography } from '@kintent/glide';

import * as Styles from './LeadershipSection.styles';
import { Flex } from '../../../../../components/Flex';
import { useAuthService, useTeamLeaderAvatar, useTeamLeaderList } from '../../../../../lib/state';
import { getTrustLeaderDisplayName } from '../../../../../lib/utils';
import DefaultProfileIcon from '../../../../../assets/default-profile.svg';

function LeaderItem(props) {
  const { item, teamId } = props;
  const leaderName = getTrustLeaderDisplayName(item);
  const [leaderAvatar] = useTeamLeaderAvatar(teamId, item.id, item.avatarFilename);

  return (
    <Card className="leadership-list-item">
      <Flex gap="12px">
        <Avatar
          className="enterprise-leader-avatar"
          size="lg"
          name={leaderName}
          src={leaderAvatar ?? item?.user?.pictureUrl ?? DefaultProfileIcon}
        />
        <Flex
          data-testid="enterprise-leader-info"
          className="enterprise-leader-info"
          direction="column"
        >
          <Typography
            as="p"
            className="leader-name"
            level="6"
            strength="100%"
          >
            {leaderName}
          </Typography>
          {item.leaderRole && (
            <Typography
              level="9"
              strength="60%"
            >
              {item?.leaderRole}
            </Typography>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}

function LeadershipSection() {
  const { currentTeam } = useAuthService();
  const [leaders] = useTeamLeaderList(currentTeam?.id);

  // Ensure we don't render the section if we don't have any leaders
  if (Array.isArray(leaders) && leaders.length === 0) return null;

  return (
    <Styles.Section data-testid="enterprise-leadership-section">
      <Typography
        as="h5"
        className="leadership-section-title"
        level="5"
        data-testid="enterprise-leadership-section-title"
      >
        Leadership
      </Typography>
      <Styles.Grid data-testid="enterprise-leadership-section-grid">
        {leaders.map((item) => {
          return (
            <LeaderItem
              key={item.id}
              teamId={currentTeam?.id}
              item={item}
            />
          );
        })}
      </Styles.Grid>
    </Styles.Section>
  );
}

export default LeadershipSection;
